<template>
    <v-modal
        :title="modalContact ? 'Consultar sobre la propiedad' : 'Quiero que me contacten'"
        :visible="modalContact || modalContactMe"
        @close="modalClose"
        fullScreen
        width="500"
    >
        <form @submit.prevent="changeMessages" class="modal-contact">
            <div class="modal-contact__control">
                <label>Nombre:</label>
                <input required type="text" v-model="messages.name" ref="nameInput" v-autofocus="autofocusValue" @blur="onBlurInput" autofocus/>
            </div>
            <div class="modal-contact__control">
                <label>Email:</label>
                <input required type="email" v-model="messages.email" ref="emailInput" />
            </div>
            <div class="modal-contact__control">
                <label>Teléfono:</label>
                <input required type="tel" v-model="messages.phone" ref="phoneInput" />
            </div>
            <div class="modal-contact__control">
                <label>Mensaje:</label>
                <textarea required rows="6" v-model="messages.message" ref="messageInput"></textarea>
            </div>
            <div class="modal-contact__actions">
                <button @click="modalClose" class="button" type="button">Cancelar</button>
                <button class="button button--green" type="submit">Enviar Mensaje</button>
            </div>
            <p class="modal-contact__terms">
                Al enviar este mensaje se aceptan los
                <router-link :to="`${path.toLowerCase()}/terminos-y-condiciones`">términos y condiciones</router-link>, así como la
                <router-link :to="`${path.toLowerCase()}/politica-de-privacidad`">política de privacidad</router-link>.
            </p>
            <v-loader border="4" size="40" v-show="loader" />
            <div class="modal-contact__messages" v-show="message !== null">
                <span v-show="message == 'success'">
                  Gracias, su consulta fue enviada correctamente


                </span>
                <span v-show="message == 'error'">
                  Oops! Algo salió mal, vuelve a intentarlo
                </span>
            </div>
        </form>
    </v-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

import { messages } from '@/services/ApiMapaprop'

import Messages from '../models/Messages.js'

export default {
    props: {
        data: { type: Object, required: true }
    },
    data() {
        return {
            loader: false,
            message: null,
            messages: new Messages(),
            autofocusValue: true
        }
    },
    mounted() {
        document.querySelector("[autofocus]").focus()
    //     console.group('vContact.vue: mounted()')
    //     console.log(this.$refs)
    //     console.log(this.data)
    //     console.groupEnd()
    },
    computed: {
        ...mapGetters({
            modalContact: 'modals/modalContact',
            modalContactMe: 'modals/modalContactMe',
            path: 'path'
        })
    },
    watch: {
        modalContact(response) {
            this.messages.message =
                'Hola\n\nQuiero recibir mas informacion sobre esta publicacion en ' + this.$appSettings.appUrl + 'o coordinar una visita.\n\nMuchas gracias.'
        },
        modalContactMe(response) {
            this.messages.message = 'Hola\n\nQuiero que me llamen por esta publicacion en ' + this.$appSettings.appUrl + '.\n\nMuchas gracias.'
        }
    },
    methods: {
        modalClose() {
            this.$store.commit('modals/modalHandler', { name: 'modalContact', boolean: false })
            this.$store.commit('modals/modalHandler', { name: 'modalContactMe', boolean: false })
            this.message = null
            this.autofocusValue = true
        },
        changeMessages() {
            this.loader = true
            this.messages.referer = this.$appSettings.appUrl
            this.messages.propertyHash = this.data.propertyHash
            this.messages.url = this.$appSettings.appUrl + this.$route.path
            this.messages.userAgent = navigator.userAgent
            this.POSTmessages()
            // axios
            // .get('https://api.ipstack.com/check?access_key=9c5ae013a2155928d2211207fbcc93b1')
            // .then((response) => {
            //     this.messages.ip = response.data.ip
            //     setTimeout(() => {
            //         this.POSTmessages()
            //     }, 500)
            // })
            // .catch((error) => {
            //     setTimeout(() => {
            //         this.loader = true
            //         this.message = 'error'
            //     }, 1000)
            // })
        },
        async POSTmessages() {
            try {
                const response = await messages(this.messages)
                this.messages = new Messages()

                // console.log(response)

                setTimeout(() => {
                  this.loader = true
                  this.message = 'success'
                }, 1000)

            } catch (error) {
              setTimeout(() => {
                this.loader = true
                this.message = 'error'
              }, 1000)
            //   console.log(error)
            }
            // console.groupEnd()
        },
        onBlurInput() {
            this.autofocusValue = false
        }
    }
}
</script>

<style lang="scss">
.modal-contact {
    position: relative;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1fr;
    &__control {
        label {
            display: inline-block;
            margin-bottom: 0.5rem;
        }
        input,
        textarea {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            border: 1px solid #e3e3e3;
            border-radius: 4px;
        }

        input {
        }
        textarea {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
        }
    }
    &__actions {
        display: flex;
        justify-content: flex-end;
        button {
            width: auto;
            &:nth-of-type(1) {
                margin-right: 1rem;
            }
        }
    }
    &__terms {
        font-size: 0.8rem;
        a {
            font-size: 0.8rem;
            color: #c9d700;
            &:hover {
                color: #888888;
            }
        }
    }

    &__messages {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        span {
            text-align: center;
        }
    }

    .v-loader {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: #ffffff;
    }
}
</style>
